export const environment = {
  production: false,
  apiUrl: "https://apitest.vizeasist.com/api",
  imageUrl: "https://cdntest.vizeasist.com",
  featureFlag: true,
};
